import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RankingsAnonFormService {
  private localStorageKey: string = 'RANKINGS_ANON_EMAIL_SUBMITTED';
  private submittedValue: string = 'true';
  private emailLocalStorageKey: string = 'ajs_user_traits';

  constructor() {}

  isFormSubmitted() {
    const value = sessionStorage.getItem(this.localStorageKey);
    return value === this.submittedValue;
  }

  submitForm() {
    sessionStorage.setItem(this.localStorageKey, this.submittedValue);
  }

  getSubmittedEmail() {
    const value = localStorage.getItem(this.emailLocalStorageKey);
    if (value) {
      return JSON.parse(value).email;
    }
    return null;
  }
}
